import { api } from '@/api';

//by email
const auth = (data) => {
  return api.post('/api/v1/auth', data);
};

const getToken = (data) => {
  return api.post('/api/v1/auth/token', data);
};

const resendEmailCode = (email, id) => {
  return api.post('/api/v1/resendEmailSms', { email: email, id: id });
};

const resetPasswordSendCode = (email) => {
  return api.post('/api/kyc/v1/investor/changePassword', { email: email });
};
const resetPassword = ({ email, newPassword, code }) => {
  return api.put('/api/kyc/v1/investor/changePassword', { email, newPassword, code });
};

const changePasswordSendCode = (email) => {
  return api.post('/api/kyc/v2/investor/changePassword', { email: email });
};
const changePassword = ({ newPassword, code }) => {
  return api.put('/api/kyc/v2/investor/changePassword', { newPassword, code });
};

export const authApi = {
  auth,
  getToken,
  resendEmailCode,
  resetPasswordSendCode,
  resetPassword,
  changePasswordSendCode,
  changePassword
};
